import { Models } from 'models/core';
import { PenOrderStatusDto } from './PenOrderStatus';

export class PenOrderDto {
  Id: number;
  OrderNumber: string;
  NumberOfPens: number;
  CustomerId: number;
  Customer: Models.Customer;
  PenOrderStatusId: number;
  PenOrderStatus: PenOrderStatusDto;
}

export class CreatePenOrderDto {
  OrderNumber: string;
  PenOfferId: number;
  ProducerId: number;
  PenIdStart: number;
  PenIdentifiers: PenIdentifierDto[];
  GlobalAnalysisId: number;
}

export class PenIdentifierDto {
  Id: number;
  Value: string;
  IsManual: boolean;
  IsFirst: boolean;
}

export class CreatePenOrderResonseDto {
  PenOrderId: number;
  PenId: number;
}

export class PenOrderListItemDto {
  Id: number;
  PenId: number;
  CustomerName: string;
  PenOrderNumber: string;
  PenOfferNumber: string;
  NumberOfPens: number;
  PorducerName: string;
}
